import { apiProxy } from '../util-lib/http';
/**
 * 获取微信jssdk
 */
export async function getJsSdk() {
  const api = 'api/v1.21/Travel/Wechat/DefaultJssdkConfig';
  const data = await apiProxy.post(api, {
    url: window.location.href
  });
  return data;
}
